import React from "react";
import { Grid, CardContent, CardHeader, Divider, Card, Fab } from "@material-ui/core";
import CommissionTable from "./CommissionTable";
import { usePageStyles } from "../../pageStyles";
import { SearchBox } from "../../components/common/SearchBox";
import { PageComponent, AccessRights } from "../../../core/navigation/types";
import AddIcon from "@material-ui/icons/Add";
import { useCommissionSearch } from "../../../data/listing/commissions/hooks/useCommissionSearch";
import { useHistory } from "react-router-dom";
import { PageTitle } from "../../components/common/PageTitle";
import { getCommissionEditLocation } from "./Locations";

const CommissionPage: PageComponent = ({ userAccessRights }) => {
	const pageStyles = usePageStyles();

	const [search, setSearch] = useCommissionSearch();
	const history = useHistory();

	return (
		<Grid container className={pageStyles.root}>
			<Grid item xs={12} className={pageStyles.gridItem}>
				<Card>
					<CardHeader
						title={<PageTitle title="commissionTitle" />}
						action={<SearchBox search={search} setSearch={setSearch} />}
					/>
					<Divider />
					<CardContent>
						<CommissionTable userAccessRights={userAccessRights} />
					</CardContent>
				</Card>
				{userAccessRights === AccessRights.All && (
					<Fab
						color="secondary"
						aria-label="add"
						className={pageStyles.mainFab}
						onClick={() => history.push(getCommissionEditLocation())}
					>
						<AddIcon />
					</Fab>
				)}
			</Grid>
		</Grid>
	);
};

export default CommissionPage;
